import { Dispatch } from "../../config/controller";
import { Atendimento, Medico, Paciente, Sala } from "../../config/data.types";
import { Model, StateProps } from "../../config/model";

export type { Atendimento } from "../../config/data.types";

export interface SessaoAtendimento {
    medico: Medico,
    sala: Sala,

}

export interface AtendimentoState extends StateProps<Atendimento> {
    sessao: SessaoAtendimento
    sessaoStarted: boolean
    pacienteChamado: Paciente
    showModalChamarPaciente: boolean
}

export interface AtendimentoActions extends Dispatch<Atendimento> {
    startAtendimento: () => any
    abrirNovoAtendimento: (sessao: SessaoAtendimento) => any
    continuarAtendimento: (row: Atendimento) => any
    readAtendimentoToday: () => any
    setShowModalChamarPaciente: (prm: SetShowModalChamarPaciente) => any
    getPacienteChamando:(paciente:Paciente) => any
    fecharSessaoAtendimento: () => any
}

export interface SetShowModalChamarPaciente {
    setModal: boolean, paciente: Paciente, chamar: boolean, finaliza: boolean
}

const model = new Model<Atendimento, AtendimentoState>("atendimento");

export const initialValueAtendimento: Atendimento = {
    ...model.getInitialValue(),
    type: "atendimento",
    data: "",
    medico: { nome: "" } as Medico,
    sala_atendimento: { descricao: "" } as Sala,
    pacientes: []
}

export const initialValueAtendimentoState: AtendimentoState = {
    ...model.getInititalValueState(),
    row: initialValueAtendimento,
    sessao: {} as SessaoAtendimento,
    sessaoStarted: false,
    showModalChamarPaciente: false,
    pacienteChamado: {} as Paciente
}


